function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import AuthClient from './client';
import { getRedirectLoginUrl } from './windowUtils';
import { routes } from '@shared/routerHistory';
import { logger } from '@src/logger';
import { stringifyError } from '@shared/utils/errorUtils';
import { Constants } from '@shared/utils/constants';
import { saveLocalStorageItem } from '@shared/utils/browserStorageUtils';
export const logoutUser = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*() {
        try {
            const { idTokenClaims } = AuthClient.getInstance().getActiveAccount();
            saveLocalStorageItem(Constants.LocalStorage.LoginHint, '');
            return yield AuthClient.getInstance().logoutRedirect({
                postLogoutRedirectUri: `${getRedirectLoginUrl()}${routes.home.getPath()}`,
                logoutHint: idTokenClaims === null || idTokenClaims === void 0 ? void 0 : idTokenClaims.login_hint
            });
        } catch (error) {
            logger.error(stringifyError(error), {
                action: Constants.Telemetry.Action.Logout,
                actionModifier: Constants.Telemetry.ActionModifier.LogoutFailed,
                error
            });
        }
    });
    return function logoutUser() {
        return _ref.apply(this, arguments);
    };
}();
